/**
 * SEO Configuration
 * Centralized configuration for SEO-related settings
 */

export const seoConfig = {
  // Google Business Profile URL (from Footer)
  gmbUrl: "https://g.co/kgs/jAcSa66/",
  
  // Business Information
  businessName: "TurfBooking.in",
  phone: "+91-9238764656",
  email: "info@turfbooking.in",
  website: "https://turfbooking.in",
  
  // Social Media Links (for sameAs in structured data)
  socialLinks: {
    googleBusiness: "https://g.co/kgs/jAcSa66/",
    instagram: "https://www.instagram.com/turfbooking.in",
    linkedin: "https://www.linkedin.com/in/turf-booking-platform-016622298",
  },
  
  // Base URL - Remove www. if present, ensure no trailing slash
  baseUrl: (() => {
    const envUrl = process.env.NEXT_PUBLIC_HOST_URL || "https://turfbooking.in";
    return envUrl.replace(/https?:\/\/(www\.)?/, 'https://').replace(/\/$/, '');
  })(),
};
